export * from './lib/type-strict';
